import * as yup from 'yup'

export const schema = yup.object().shape({
  description: yup.string().label('Description'),
  recordingTypeValue: yup.string(),
  dueAt: yup.date().label('Date').nullable(),
  title: yup.string().required().label('Title')
})
